import React from 'react';
import { motion } from 'framer-motion';
import { Star, BookOpen, Users, Sparkles, Printer, Smartphone } from 'lucide-react';
export function PricingCards() {
  return <section id="pricing" className="py-20 bg-gray-50" data-id="element-159">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-160">
        <div className="text-center mb-12" data-id="element-161">
          <h2 className="text-4xl md:text-5xl text-wc-dark mb-3" data-id="element-162">
            📦 ¿QUÉ INCLUYE EL MEGAPACK?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-163">
            Elegí la opción que mejor se adapte a tu pasión mundialista
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch" data-id="element-164">
          {/* Pack 2 — MÁS VENDIDA — ahora primero */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl shadow-2xl border-4 border-wc-yellow overflow-hidden flex flex-col relative" data-id="element-165">
            <div className="absolute top-0 left-0 w-full bg-wc-yellow text-wc-dark text-center py-1.5 font-bold tracking-widest text-xs uppercase flex items-center justify-center gap-2 z-10" data-id="element-166">
              <Star size={14} fill="currentColor" data-id="element-167" /> LA MÁS ELEGIDA{' '}
              <Star size={14} fill="currentColor" data-id="element-168" />
            </div>

            <div className="bg-wc-dark p-5 pt-10 text-center border-b border-gray-800" data-id="element-169">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-wc-yellow text-wc-dark rounded-full mb-3" data-id="element-170">
                <span className="text-xl font-bold" data-id="element-171">👑</span>
              </div>
              <h3 className="text-2xl font-display text-white mb-1" data-id="element-172">
                OFERTA 1
              </h3>
              <h4 className="text-base font-bold text-wc-yellow mb-3" data-id="element-173">
                MEGAPACK HISTÓRICO COMPLETO
              </h4>
              <div className="flex items-center justify-center gap-2" data-id="element-174">
                <span className="text-lg text-gray-400 line-through" data-id="element-175">
                  $45.000
                </span>
                <span className="text-4xl font-display text-white" data-id="element-176">
                  $27.990
                </span>
              </div>
            </div>

            <div className="p-5 flex-1 flex flex-col" data-id="element-177">
              <div className="mb-4 pb-4 border-b border-gray-200" data-id="element-178">
                <p className="font-bold text-sm text-center text-gray-900" data-id="element-179">
                  ✅ Todo lo del Pack 2026 + Los Mundiales más Épicos de la
                  Historia
                </p>
              </div>

              <ul className="space-y-2 flex-1 text-sm" data-id="element-180">
                <li className="flex items-center gap-2 bg-yellow-50 p-2.5 rounded-lg border border-yellow-100" data-id="element-181">
                  <Star className="w-4 h-4 text-wc-yellow flex-shrink-0" fill="currentColor" data-id="element-182" />
                  <span className="font-bold text-gray-900" data-id="element-183">
                    BONO 1: Álbum + Figuritas Qatar 2022
                  </span>
                </li>
                <li className="flex items-center gap-2 bg-yellow-50 p-2.5 rounded-lg border border-yellow-100" data-id="element-184">
                  <Star className="w-4 h-4 text-wc-yellow flex-shrink-0" fill="currentColor" data-id="element-185" />
                  <span className="font-bold text-gray-900" data-id="element-186">
                    BONO 2: Álbum + Figuritas Rusia 2018
                  </span>
                </li>
                <li className="flex items-center gap-2 bg-yellow-50 p-2.5 rounded-lg border border-yellow-100" data-id="element-187">
                  <Star className="w-4 h-4 text-wc-yellow flex-shrink-0" fill="currentColor" data-id="element-188" />
                  <span className="font-bold text-gray-900" data-id="element-189">
                    BONO 3: Álbum + Figuritas Brasil 2014
                  </span>
                </li>
                <li className="flex items-center gap-2 bg-yellow-50 p-2.5 rounded-lg border border-yellow-100" data-id="element-190">
                  <Star className="w-4 h-4 text-wc-yellow flex-shrink-0" fill="currentColor" data-id="element-191" />
                  <span className="font-bold text-gray-900" data-id="element-192">
                    BONO 4: Álbum + Figuritas Sudáfrica 2010
                  </span>
                </li>
              </ul>

              <div className="mt-4 p-3 bg-gray-50 rounded-lg italic text-gray-600 text-center text-xs" data-id="element-193">
                💬 "Una colección histórica completa que no vas a encontrar en
                ningún otro lado."
              </div>

              <a href="https://www.digitalbibliotec.online/cart/52276164100378:1" target="_blank" rel="noopener noreferrer" className="w-full mt-4 bg-wc-red hover:bg-red-700 text-white font-bold py-4 rounded-xl text-lg transition-transform transform hover:scale-105 shadow-lg text-center block" data-id="element-194">
                QUIERO EL PACK HISTÓRICO
              </a>
            </div>
          </motion.div>

          {/* Pack 1 — ahora segundo */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden flex flex-col" data-id="element-195">
            <div className="bg-gray-100 p-5 text-center border-b border-gray-200" data-id="element-196">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-wc-blue text-white rounded-full mb-3" data-id="element-197">
                <span className="text-xl font-bold" data-id="element-198">🥇</span>
              </div>
              <h3 className="text-2xl font-display text-wc-dark mb-1" data-id="element-199">
                OFERTA 2
              </h3>
              <h4 className="text-base font-bold text-gray-600 mb-3" data-id="element-200">
                MEGAPACK ÁLBUM 2026
              </h4>
              <div className="text-4xl font-display text-wc-blue" data-id="element-201">$19.990</div>
            </div>

            <div className="p-5 flex-1 flex flex-col" data-id="element-202">
              <ul className="space-y-3 flex-1 text-sm" data-id="element-203">
                <li className="flex gap-3" data-id="element-204">
                  <BookOpen className="w-5 h-5 text-wc-blue flex-shrink-0 mt-0.5" data-id="element-205" />
                  <div data-id="element-206">
                    <p className="font-bold text-gray-900" data-id="element-207">
                      Álbum 2026 Completo en PDF
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-208">
                      Listo para imprimir, igual al original Panini
                    </p>
                  </div>
                </li>
                <li className="flex gap-3" data-id="element-209">
                  <Users className="w-5 h-5 text-wc-blue flex-shrink-0 mt-0.5" data-id="element-210" />
                  <div data-id="element-211">
                    <p className="font-bold text-gray-900" data-id="element-212">
                      Figuritas de TODOS los equipos
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-213">
                      Argentina, Brasil, Francia, Portugal, España, México,
                      Colombia y más
                    </p>
                  </div>
                </li>
                <li className="flex gap-3" data-id="element-214">
                  <Sparkles className="w-5 h-5 text-wc-blue flex-shrink-0 mt-0.5" data-id="element-215" />
                  <div data-id="element-216">
                    <p className="font-bold text-gray-900" data-id="element-217">
                      Figuritas Especiales
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-218">
                      Las más codiciadas del álbum
                    </p>
                  </div>
                </li>
                <li className="flex gap-3" data-id="element-219">
                  <Printer className="w-5 h-5 text-wc-blue flex-shrink-0 mt-0.5" data-id="element-220" />
                  <div data-id="element-221">
                    <p className="font-bold text-gray-900" data-id="element-222">
                      Instructivo de Impresión
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-223">
                      Guía paso a paso para imprimir en casa o en copistería
                    </p>
                  </div>
                </li>
                <li className="flex gap-3" data-id="element-224">
                  <Smartphone className="w-5 h-5 text-wc-blue flex-shrink-0 mt-0.5" data-id="element-225" />
                  <div data-id="element-226">
                    <p className="font-bold text-gray-900" data-id="element-227">
                      Acceso Digital Inmediato
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-228">
                      Lo recibís al instante en tu correo
                    </p>
                  </div>
                </li>
              </ul>

              <a href="https://www.digitalbibliotec.online/cart/52276163608858:1" target="_blank" rel="noopener noreferrer" className="w-full mt-5 bg-wc-blue hover:bg-blue-800 text-white font-bold py-3 rounded-xl text-base transition-colors text-center block" data-id="element-229">
                QUIERO EL MEGAPACK 2026
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}